import {MAX_PR_AGE_COOKIE_NAME} from '@github-ui/shared-dashboard-surface/constants/cookies'
import type {PullsInboxMaxAge} from '../types/routes-types'
import {setPreferenceCookie} from '@github-ui/shared-dashboard-surface/helpers/preference-cookies'
import {persistPullsPreferences} from '@github-ui/shared-dashboard-surface/helpers/pulls-preferences-api'

/**
 * Persists the inbox "max PR age" filter. The cookie is always written as the
 * fast read path. The value is also persisted to the dashboard surface
 * preferences table, which dual-writes UserSettings.
 */
export async function saveInboxMaxPrAge(maxPrAge: PullsInboxMaxAge): Promise<void> {
  setPreferenceCookie(MAX_PR_AGE_COOKIE_NAME, maxPrAge)
  persistPullsPreferences({max_pr_age: maxPrAge})
}
